import React from "react";
import logo from "../utils/images/JA-logo.png";
import classes from "./LandingPageNav.module.css";
import SearchIcon from "@mui/icons-material/Search";
import HomeIcon from "@mui/icons-material/Home";
import LightbulbIcon from "@mui/icons-material/Lightbulb"; 
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo"; 
import ContactMailIcon from "@mui/icons-material/ContactMail";
import { NavLink, Link } from "react-router-dom";

const LandingPageNav = () => {
  return (
    <div className={classes.mainNavbar}>
      <div className={classes.navBar}>
        <div className={classes.logo}>
          <img src={logo} alt="logo" />
        </div>
        <div className={classes.navItemsLP}>
          <ul>
            <li>
              <NavLink
                className={({ isActive }) => (isActive ? classes.active : undefined)}
                to="/"
                end
              >
                <span className={classes.NavTabName}>Home</span>
                <span className={classes.buttonNav}>
                  <HomeIcon />
                </span>
              </NavLink>
            </li>
            <li>
              <NavLink
                className={({ isActive }) => (isActive ? classes.active : undefined)}
                to="/inspiration"
              >
                <span className={classes.NavTabName}>Inspiration</span>
                <span className={classes.buttonNav}>
                  <LightbulbIcon />
                </span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/demo">
                <span className={classes.NavTabName}>Demo</span>
                <span className={classes.buttonNav}>
                  <OndemandVideoIcon />
                </span>
              </NavLink>
            </li>
            <li>
              <NavLink
                className={({ isActive }) => (isActive ? classes.active : undefined)}
                to="/contact"
              >
                <span className={classes.NavTabName}>Contact Us</span>
                <span className={classes.buttonNav}>
                  <ContactMailIcon />
                </span>
              </NavLink>
            </li>
          </ul>
        </div>
        <div className={classes.searchBar}>
          <form>
            <input placeholder="Search here" type="text" />
            <button type="submit">
              <SearchIcon />
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LandingPageNav;